module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_04.jpg?v=dff0737e";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_04.jpg
 ** module id = 61
 ** module chunks = 1 2
 **/